const formatTravelMode = (value) => {
  if (!value) return 'Unknown';
  const cleaned = `${value}`.replace(/[_-]+/g, ' ').trim();
  if (!cleaned) return 'Unknown';
  return cleaned
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const resolveTourTravelMode = (tour, tourStops = []) => {
  const candidates = [
    tour?.travelType,
    tour?.legs?.[0]?.travelMode,
    ...tourStops.map((stop) => stop?.travelMode ?? stop?.mode ?? stop?.leg?.travelMode),
  ].filter(Boolean);
  const raw = `${candidates[0] ?? ''}`.toLowerCase();
  if (!raw) return { label: 'Unknown', google: 'WALK' };
  if (raw.includes('walk')) return { label: 'Walking', google: 'WALK' };
  if (raw.includes('drive') || raw.includes('car')) return { label: 'Driving', google: 'DRIVE' };
  return { label: formatTravelMode(raw), google: raw.toUpperCase() };
};

export const resolveScheduleTour = (schedule, tours = [], fallbackTour = null) => {
  if (!schedule || schedule.entity?.type !== 'Tour') return null;
  const direct =
    schedule.tour ||
    schedule.tourData ||
    schedule.entity?.tour ||
    schedule.entity?.data ||
    schedule.entity?.details ||
    null;
  if (direct && (direct.id != null || direct.nodes || direct.legs || direct.encodedPolyline)) {
    return direct;
  }
  if (fallbackTour && (fallbackTour.id != null || fallbackTour.nodes || fallbackTour.legs)) {
    const fallbackId =
      fallbackTour.id ??
      fallbackTour.tourId ??
      fallbackTour.routeId ??
      null;
    const targetId =
      schedule.entity?.entity_id ??
      schedule.entity?.id ??
      schedule.entityId ??
      schedule.entity_id ??
      null;
    if (targetId == null || fallbackId == null || `${fallbackId}` === `${targetId}`) {
      return fallbackTour;
    }
  }
  const targetId =
    schedule.entity?.entity_id ??
    schedule.entity?.id ??
    schedule.entityId ??
    schedule.entity_id ??
    null;
  if (targetId == null) return null;
  return Array.isArray(tours)
    ? tours.find((tour) => `${tour.id}` === `${targetId}`) || null
    : null;
};

export const resolveTourStops = (tour) => {
  if (Array.isArray(tour?.nodes) && tour.nodes.length) return tour.nodes;
  if (Array.isArray(tour?.stops) && tour.stops.length) return tour.stops;
  if (Array.isArray(tour?.checkpoints) && tour.checkpoints.length) return tour.checkpoints;
  return [];
};

export const pickStopLabel = (stop, fallback) => {
  if (!stop) return fallback;
  return stop.name || stop.label || stop.address || fallback;
};
